import { FaTwitter } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaVimeoV } from "react-icons/fa";
import { FaSkype } from "react-icons/fa";

export const carousel = {
  image1: {
    mobile: "/assets/carousel/bg-2/bg-2-mobile.jpg",
    tablet: "/assets/carousel/bg-2/bg-2-tablet.jpg",
    desktop: "/assets/carousel/bg-2/bg-2-desktop.jpg",
  },
  image2: {
    mobile: "/assets/carousel/bg-6/bg-6-mobile.jpg",
    tablet: "/assets/carousel/bg-6/bg-6-tablet.jpg",
    desktop: "/assets/carousel/bg-6/bg-6-desktop.jpg",
  },
  image3: {
    mobile: "/assets/carousel/bg-11/bg-11-mobile.jpg",
    tablet: "/assets/carousel/bg-11/bg-11-tablet.jpg",
    desktop: "/assets/carousel/bg-11/bg-11-desktop.jpg",
  },
};

export const learn = [
  {
    what: "Adopt",
    how: "Visit with our pets ready for adoption. Come meet your perfect match today!",
    img: "/assets/learn_how/Untitled-1.png",
  },
  {
    what: "Foster",
    how: "Without fostering, there can be no rescue. Every year we save the lives of over 500 pets.",
    img: "/assets/learn_how/Untitled-2.png",
  },
  {
    what: "Donate",
    how: "Every little bit counts! Your genereous donation helps animals most in need.",
    img: "/assets/learn_how/Untitled-3.png",
  },
  {
    what: "Volunteer",
    how: "You can help animals that we would otherwise not be able to facilitate.",
    img: "/assets/learn_how/Untitled-4.png",
  },
];

export const companions = [
  {
    name: "Bosco",
    story:
      "Bosco came to the shelter when someone in his family became allergic. He's an affectionate guy who.. enjoys catnip and watching...",
    img: "/assets/companions/bosco-580x460.jpg",
  },
  {
    name: "Buck",
    story:
      "Buck came to the shelter when someone in his family became allergic. He's an affectionate guy who.. enjoys catnip and watching...",
    img: "/assets/companions/buck-580x460.jpg",
  },
  {
    name: "Jeffrey",
    story:
      "Jeffrey came to the shelter when someone in his family became allergic. He's an affectionate guy who.. enjoys catnip and watching...",
    img: "/assets/companions/1jeffrey-580x460.jpg",
  },
  {
    name: "Belle",
    story:
      "Belle came to the shelter when someone in her family became allergic. He's an affectionate guy who.. enjoys catnip and watching...",
    img: "/assets/companions/minnie-580x460.jpg",
  },
];

export const recent = [
  {
    date: "January 1, 2015",
    title: "Top 10 Pet Care Tips",
    story:
      "Keep your feline friends and canine companions healthy and happy by following these 10 pet care tips the pros want you to know. Que ne duis graeco, cum tempor...",
    image: "/assets/events/14041894574_05273fd5f5_o-250x250.jpg",
  },
  {
    date: "January 9, 2015",
    title: "How to: Safely Bring home a Resuce or Shelter Dog",
    story:
      "Congratulations on choosing to adopt a rescue dog! At vero eos et accuamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque ...",
    image: "/assets/events/Licking-dog-250x250.jpg",
  },
  {
    date: "January 5, 2015",
    title: "Ready for Adoption This Month",
    story:
      "Get familiary to these cuties ready for adoption! Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus...",
    image: "/assets/events/left-eye-copy-250x250.jpg",
  },
];

export const events = [
  {
    month: "JUN",
    day: "11",
    time: "06/11/2023 / 6:00 pm - 09/13/2024 / 7:00 pm",
    event: "Animal Shelter Volunteers Meeting",
  },
  {
    month: "NOV",
    day: "11",
    time: "11/11/2023 / 6:00 pm - 02/19/2025 / 9:00 pm",
    event: "Meet & Greet Adoption Event",
  },
  {
    month: "DEC",
    day: "9",
    time: "12/9/2023 / 11:00am - 03/22/2025 / 8:00 pm",
    event: "Kitten Adoption Days",
  },
];

export const antiCrueltySociety = [
  "adoption information",
  "dog training classes",
  "employment/internships",
  "humane education",
  "veterinary clinic",
  "report animal abuse",
];

export const spayAndNeuterClinic = [
  "spay neuter",
  "after surgery instructions",
  "mandatory tattooing with spay surgeries",
  "charity veterinary clinic",
  "schedule Spay/Neuter surgery",
  "volunteer",
];

export const trainingYourPet = [
  "training your dog",
  "training your cat",
  "workshops for dogs",
  "introducing your dog to other pets and babies",
  "introducing your cart to other pets and babies",
];

export const adoptionInformation = [
  "adoption information",
  "adopt a cat",
  "adopt a dog",
  "adoption programs",
  "our adoption partners",
];

export const social = [
  { media: "twitter", icon: <FaTwitter /> },
  { media: "facebook", icon: <FaFacebookF /> },
  { media: "linkedin", icon: <FaLinkedinIn /> },
  { media: "vimeo", icon: <FaVimeoV /> },
  { media: "Skype", icon: <FaSkype /> },
];

export const links = ["About Us", "All Pets", "Contacts"];

export const navigation = [
  "home",
  "pets",
  "layouts",
  "post types",
  "shortcodes",
  "shop",
  "contacts",
];

export const navMenu = [
  // 0-3
  {
    tier: 1,
    item: "HOME",
  },
  {
    tier: 2,
    item: "Right Navigation",
  },
  {
    tier: 2,
    item: "Classic Navigation",
  },
  {
    tier: 2,
    item: "Center Navigation",
  },

  // 4-10
  {
    tier: 1,
    item: "PETS",
  },
  {
    tier: 2,
    item: "All Pets",
  },
  {
    tier: 2,
    item: "Adoptable Dogs",
  },
  {
    tier: 3,
    item: "All Dogs",
  },
  {
    tier: 3,
    item: "Adult Dogs",
  },
  {
    tier: 3,
    item: "Puppies",
  },
  {
    tier: 2,
    item: "Adoptable Cats",
  },
  {
    tier: 3,
    item: "All Cats",
  },
  {
    tier: 3,
    item: "Adult Cats",
  },
  {
    tier: 3,
    item: "Kittens",
  },

  // 14-16
  {
    tier: 1,
    item: "LAYOUTS",
  },
  {
    tier: 2,
    item: "About Us",
  },
  {
    tier: 2,
    item: "Adoption Info",
  },
  {
    tier: 2,
    item: "Adoption Fees",
  },
  {
    tier: 2,
    item: "Donation",
  },
  {
    tier: 2,
    item: "Typography",
  },

  // 17-37
  {
    tier: 1,
    item: "POST TYPES",
  },

  // 18-21
  {
    tier: 2,
    item: "PROJECT GRID",
  },
  {
    tier: 3,
    item: "Large Gap",
  },
  {
    tier: 3,
    item: "1Pixel Gap",
  },
  {
    tier: 3,
    item: "No Gap",
  },

  // 22-25
  {
    tier: 2,
    item: "MASSONRY PUZZLE",
  },
  {
    tier: 3,
    item: "Large Gap",
  },
  {
    tier: 3,
    item: "1Pixel Gap",
  },
  {
    tier: 3,
    item: "No Gap",
  },

  // 26-29
  {
    tier: 2,
    item: "BLOG",
  },
  {
    tier: 3,
    item: "Standard Blog",
  },
  {
    tier: 3,
    item: "Masonry Blog",
  },
  {
    tier: 3,
    item: "Timeline Blog",
  },

  // 30-33
  {
    tier: 2,
    item: "PROFILES",
  },
  {
    tier: 3,
    item: "Horizontal",
  },
  {
    tier: 3,
    item: "Vertical",
  },
  {
    tier: 3,
    item: "Open Profile",
  },

  // 34-37
  {
    tier: 2,
    item: "EVENTS",
  },
  {
    tier: 3,
    item: "Photo",
  },
  {
    tier: 3,
    item: "Month",
  },
  {
    tier: 3,
    item: "Map",
  },

  // 38-65
  {
    tier: 1,
    item: "SHORTCODES",
  },
  {
    tier: 2,
    item: "Toggles & Accordions",
  },
  {
    tier: 2,
    item: "Tabs & Tours",
  },
  {
    tier: 2,
    item: "Quotes",
  },
  {
    tier: 2,
    item: "Icon Lists",
  },
  {
    tier: 2,
    item: "Icon Boxes",
  },
  {
    tier: 2,
    item: "Special Headings",
  },
  {
    tier: 2,
    item: "Posts or Projects Slider",
  },
  {
    tier: 2,
    item: "Clients",
  },
  {
    tier: 2,
    item: "Dividers",
  },
  {
    tier: 2,
    item: "Images",
  },
  {
    tier: 2,
    item: "Google Maps",
  },
  {
    tier: 2,
    item: "Featured Blocks",
  },
  {
    tier: 2,
    item: "Tables",
  },
  {
    tier: 2,
    item: "Blog Shortcode",
  },
  {
    tier: 2,
    item: "Notice Boxes",
  },
  {
    tier: 2,
    item: "Counters & Progress Bars",
  },
  {
    tier: 2,
    item: "Buttons & Icons",
  },
  {
    tier: 2,
    item: "Social Sharing",
  },
  {
    tier: 2,
    item: "Gallery",
  },
  {
    tier: 2,
    item: "Portfolio Shortcode",
  },
  {
    tier: 2,
    item: "Embedded",
  },
  {
    tier: 2,
    item: "Custom HTML, CSS, JS",
  },
  {
    tier: 2,
    item: "Sidebar",
  },
  {
    tier: 2,
    item: "Sliders",
  },
  {
    tier: 2,
    item: "Profiles",
  },
  {
    tier: 2,
    item: "Pricing Tables",
  },
  {
    tier: 2,
    item: "Tweets",
  },

  // 66
  {
    tier: 1,
    item: "SHOP",
  },

  // 67
  {
    tier: 1,
    item: "CONTACTS",
  },
];
